// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Confirm from 'components/Confirm/Confirm'
import Loading from 'components/Loading/Loading'
import Text from 'components/Form/Text'
import Select from 'components/Form/Select'
import Checkmark from 'components/svg/checkmark.svg'

// Redux:
import * as reduxUser from 'actions/user'

class Profile extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			formState: '',
			changed: false,
			updated: false,
			updating: false,
			userName: '',
			address: '',
			state: '',
			postcode: '',
			email: '',
			phone: '',
			password: '',
			confirmDeleteAccount: false,
			deletingAccount: false
		}

		this.state = state
	}

	componentDidMount() {
		window.scrollTo( 0, 0 )

		const { accountData, dispatch } = this.props

		if ( accountData && accountData.email ) {
			this.setState( {
				userName: accountData.name,
				address: accountData.address,
				state: accountData.state,
				postcode: accountData.postcode,
				email: accountData.email,
				phone: accountData.phone,
				password: '',
				changed: false
			} )
		}
	}

	componentDidUpdate( prevProps ) {
		const { accountData } = this.props
		const { updating } = this.state

		if ( accountData && accountData.email && prevProps.accountData !== accountData ) {
			this.setState( {
				userName: accountData.name,
				address: accountData.address,
				state: accountData.state,
				postcode: accountData.postcode,
				email: accountData.email,
				phone: accountData.phone,
			} )
		}

		if ( updating && accountData && accountData.updated_at && prevProps.accountData.updated_at !== accountData.updated_at ) {
			this.setState( {
				updating: false,
				formState: 'is-processed'
			} )

			setTimeout( () => {
				this.setState( {
					formState: 'is-successful'
				} )

				setTimeout( () => {
					this.setState( {
						formState: '',
						updated: true
					} )
				}, 1000 )
			}, 1000 )
		}

		if ( accountData && accountData.deleted && ! prevProps.accountData.deleted ) {
			this.setState( {
				deletingAccount: false,
				accountDeleted: true
			} )
		}
	}

	handleChange = ( id, value ) => {
		this.setState( {
			changed: true,
			[ id ]: value
		} )
	}

	handleSubmit = ( e ) => {
		e.preventDefault()

		const { dispatch, accountData } = this.props
		const { userName, address, state, postcode, email, phone, password } = this.state

		this.setState( {
			updated: false,
			updating: true,
			formState: 'is-processing'
		} )

		const userMetadata = {
			name: userName,
			address,
			state,
			postcode,
			email,
			phone
		}

		if ( password ) {
			userMetadata.password = password
		}

		dispatch( reduxUser.saveProfile( userMetadata ) )
	}

	handleClickDeleteAccount = ( e ) => {
		e.preventDefault()

		this.setState( {
			confirmDeleteAccount: true
		} )
	}

	handleConfirmDeleteAccount = () => {
		const { dispatch } = this.props

		dispatch( reduxUser.deleteAccount() )

		this.setState( {
			deletingAccount: true,
			confirmDeleteAccount: false
		} )
	}

	handleCancelDeleteAccount = () => {
		this.setState( {
			confirmDeleteAccount: false
		} )
	}

	render() {
		const { accountData } = this.props
		let {
			userName, address, state, postcode, email, phone, password,
			formState, updating, updated, changed,
			confirmDeleteAccount, deletingAccount, accountDeleted
		} = this.state
		let buttonText = updated && ! changed ? 'Updated': 'Update'
		let buttonClass = updating ? 'button is-loading' : 'button'
		let buttonDisabled = ! changed
		const className = `form ${formState}`
		let showForm = true

		if ( ! accountData ) {
			return null
		}

		if ( deletingAccount || accountDeleted ) {
			showForm = false
		}

		return (
			<div className="page-plain">
				<div className="-inner">
					<div className="-content">
						{ confirmDeleteAccount &&
							<Confirm
								handleAccept={ this.handleConfirmDeleteAccount }
								handleCancel={ this.handleCancelDeleteAccount }
								heading="Are you sure you want to delete your account?"
								cancelText="Cancel"
								acceptText="Delete my account"
							/>
						}

						{ deletingAccount && <Loading /> }

						{ accountDeleted &&
							<div className="callout">
								<div className="-icon"><Checkmark /></div>
								<div className="-text">
									<p>Your account has been deleted.</p>
								</div>
							</div>
						}

						{ updated && ! updating &&
							<div className="callout">
								<div className="-icon"><Checkmark /></div>
								<div className="-text">
									<p>Your profile has been updated.</p>
								</div>
							</div>
						}

						{ showForm &&
							<form className={ className } onSubmit={ this.handleSubmit }>
								<h2>My Profile</h2>

								<div className="form-section">
									<Text
										id="userName"
										label="Name"
										value={ userName }
										onChange={ this.handleChange }
									/>

									<Text
										id="address"
										label="Address"
										value={ address }
										onChange={ this.handleChange }
									/>

									<div className="form-item form-items-row">
										<Select
											id="state"
											label="State"
											value={ state }
											onChange={ this.handleChange }
											options={ [
												{
													value: '',
													name: 'Select state'
												},
												{
													value: 'VIC',
													name: 'VIC'
												},
												{
													value: 'NSW',
													name: 'NSW'
												},
												{
													value: 'ACT',
													name: 'ACT'
												},
												{
													value: 'QLD',
													name: 'QLD'
												},
												{
													value: 'NT',
													name: 'NT'
												},
												{
													value: 'WA',
													name: 'WA'
												},
												{
													value: 'SA',
													name: 'SA'
												},
												{
													value: 'TAS',
													name: 'TAS'
												}
											] }
										/>

										<Text
											type="number"
											id="postcode"
											label="Postcode"
											value={ postcode }
											onChange={ this.handleChange }
										/>
									</div>

									<div className="form-item form-items-row">
										<Text
											type="email"
											id="email"
											label="Email"
											value={ email }
											onChange={ this.handleChange }
										/>

										<Text
											id="phone"
											label="Phone"
											value={ phone }
											onChange={ this.handleChange }
										/>
									</div>

									<Text
										type="password"
										id="password"
										label="Create a password (leave blank for no change)"
										onChange={ this.handleChange }
										uncontrolled={ true }
									/>

									<div className="form-item buttons">
										<button className="button" type="submit"><span className="-state"></span><span className="-progress"></span>{ buttonText }</button>

										<Link to="/" className="button button-ghost">Back</Link>
									</div>
								</div>
							</form>
						}

						{ showForm &&
							<div className="delete-account">
								<h2>Delete Account</h2>

								<p>
									<button type="button" className="button button-danger" onClick={ this.handleClickDeleteAccount }>Delete account</button>
								</p>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.user.accountData
	}
}

export default connect( mapStateToProps )( Profile )
